module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0104.jpg?v=abe825d0";